import { BotMessage, Message } from 'src/types';

export function editMessage(messages: Message[], message: Message): Message[] {
	return messages.map((msg) => (msg.id === message.id ? message : msg));
}

export function checkIsBotMessage(message: Message): message is BotMessage {
	return (message as BotMessage).sources !== undefined;
}

export function retrieveLastBotMessage(messages: Message[]) {
	const lastMessage = { ...messages[messages.length - 1] } as BotMessage;
	if (!checkIsBotMessage(lastMessage)) throw new Error('Is not a bot message');
	return lastMessage;
}
